/**
 * Dialog Components
 *
 * Abstraction layer over MUI Dialog components.
 * Exports Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText.
 */

import {
  DialogActionsProps,
  DialogContentProps,
  DialogContentTextProps,
  DialogProps,
  DialogTitleProps,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle as MuiDialogTitle,
} from '@mui/material';
import React from 'react';

export const Dialog = React.forwardRef<HTMLDivElement, DialogProps>((props, ref) => {
  return <MuiDialog ref={ref} {...props} />;
});

export const DialogTitle = React.forwardRef<HTMLDivElement, DialogTitleProps>((props, ref) => {
  return <MuiDialogTitle ref={ref} {...props} />;
});

export const DialogContent = React.forwardRef<HTMLDivElement, DialogContentProps>((props, ref) => {
  return <MuiDialogContent ref={ref} {...props} />;
});

export const DialogActions = React.forwardRef<HTMLDivElement, DialogActionsProps>((props, ref) => {
  return <MuiDialogActions ref={ref} {...props} />;
});

export const DialogContentText = React.forwardRef<HTMLParagraphElement, DialogContentTextProps>((props, ref) => {
  return <MuiDialogContentText ref={ref} {...props} />;
});

Dialog.displayName = 'Dialog';
DialogTitle.displayName = 'DialogTitle';
DialogContent.displayName = 'DialogContent';
DialogActions.displayName = 'DialogActions';
DialogContentText.displayName = 'DialogContentText';

export default Dialog;
